import { combineReducers } from '@reduxjs/toolkit';

const reducer = combineReducers({});

export * from './supplier-api-slice';

export default reducer;
